import React from "react";

export const clampDays = (v) => Math.min(365, Math.max(1, parseInt(v, 10) || 0));

export const DurationField = ({ value, onChange, presets = [7, 14], testid = "duration", dark = "bg-[#0d0d0d]" }) => (
  <div>
    <label htmlFor={`${testid}-input`} className="text-[10px] font-bold uppercase tracking-widest text-white/45 block mb-1.5">Trial duration (days)</label>
    <div className="flex gap-1.5">
      <input id={`${testid}-input`} data-testid={`${testid}-input`} type="number" inputMode="numeric" min="1" max="365" value={value}
        onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, "").slice(0, 3))}
        onBlur={() => value !== "" && onChange(String(clampDays(value)))}
        className={`w-24 ${dark} border border-white/10 rounded-md px-3 py-2.5 text-[16px] sm:text-sm text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]`} />
      {presets.map((d) => (
        <button key={d} type="button" data-testid={`${testid}-preset-${d}`} onClick={() => onChange(String(d))}
          className={`min-h-[44px] px-3 rounded-md border text-[11px] font-bold uppercase tracking-wider transition-colors ${String(d) === String(value) ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#D4AF37]" : "border-white/15 text-white/55 hover:text-white"}`}>{d}-day</button>
      ))}
    </div>
    <p className="text-[10px] text-white/40 mt-1">e.g. 42 days for a 6-week winter training block</p>
  </div>
);
